import { PrinterOutlined } from '@ant-design/icons';
import { Alert, Button, Input, Modal, Space, Switch, Typography } from 'antd';
import React, { useState } from 'react'
import AttestationCEDEAOToPrint from '../../components/docs/AttestationCEDEAOToPrint';
import AttestationCEDEAO from '../../components/docs/AttestationCEDEAO';
import { enginsPourAttestation } from './enginsPourAttestation';
import { aConducteurDifferent } from '../../components/docs/attestationDriver';

const { Title } = Typography;

const ImprimerAttestationCEDEAO = ({
    modalCEDEAOAttOpen,
    setModalCEDEAOAttOpen,
    contrat,
    printedCEDEAOAttestation,
    printingCEDEAOAttestation,
    printingDamagedCEDEAOAttestation,
    setPrintingCEDEAOAttestation,
    numeroAttestation,
    setNumeroAttestation,
    attestationCEDEAOPrinting,
    attestationCEDEAONonPrintedPrinting,
    attestationCEDEAODamagedPrinting,
    attestationDamaged,
    setAttestationDamaged,
    regle,
    rightsService,
    onTabsChange
}) => {
    const secondaryColor = "#242166";
    // Numéro d'attestation FACULTATIF, saisi PAR ENGIN (une flotte = plusieurs attestations).
    const [numeros, setNumeros] = useState({});
    // Nom sur l'attestation : assuré par défaut ; interrupteur (mono-engin) pour basculer sur le
    // conducteur habituel s'il est saisi ≠ de l'assuré.
    const enginsImpr = enginsPourAttestation(contrat);
    const isFlotte = (enginsImpr?.length || 0) > 1;
    const [auConducteur, setAuConducteur] = useState(false);
    const conducteurDispo = !isFlotte && aConducteurDifferent(contrat, enginsImpr?.[0]);
    const preferSous = !(conducteurDispo && auConducteur);
    return (
        <Modal
            title={
                <Title level={4} style={{ margin: 0, color: secondaryColor }}>
                    <PrinterOutlined style={{ marginRight: 8 }} />
                    Attestation CEDEAO
                </Title>
            }
            open={modalCEDEAOAttOpen}
            onCancel={() => {
                onTabsChange("1");
                setModalCEDEAOAttOpen(false);
            }}
            footer={null}
            width={1200}
            centered
            bodyStyle={{ padding: "24px" }}
            zIndex={2000}
        >
            {conducteurDispo && (
                <Alert type="info" showIcon style={{ marginBottom: 12 }}
                    message={
                        <Space wrap>
                            <span>Nom sur l'attestation :</span>
                            <Switch checked={auConducteur} onChange={setAuConducteur}
                                checkedChildren="Conducteur" unCheckedChildren="Assuré" />
                            <span style={{ color: '#6b7280' }}>
                                {auConducteur
                                    ? `Conducteur habituel : ${enginsImpr?.[0]?.conducteurHabituel?.nom || ''} ${enginsImpr?.[0]?.conducteurHabituel?.prenom || ''}`.trim()
                                    : `Assuré : ${contrat?.souscripteur?.nom || ''} ${contrat?.souscripteur?.prenom || ''}`.trim()}
                            </span>
                        </Space>
                    }
                />
            )}
            {
                enginsImpr?.map((eng, id) => (
                    <div key={id}>
                        <div className="container" justify="center" >
                            <div
                                className="grid-item"
                                lg={12}
                            >
                                <div ref={printedCEDEAOAttestation}>
                                    {printingCEDEAOAttestation ?
                                        <AttestationCEDEAOToPrint
                                            contrat={contrat}
                                            engin={eng}
                                            preferSouscripteur={preferSous}
                                        /> :
                                        <AttestationCEDEAO
                                            contrat={contrat}
                                            engin={eng}
                                            preferSouscripteur={preferSous}
                                        />
                                    }

                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                        </div>
                        {/* Numéro d'attestation FACULTATIF (par engin) : enregistré pour l'état des
                            attestations CEDEAO imprimées. Vide = impression sans numéro. */}
                        <Space wrap>
                            <Input
                                placeholder="N° attestation (facultatif)"
                                value={numeros[eng?.codeId] || ""}
                                onChange={(e) => setNumeros((prev) => ({ ...prev, [eng?.codeId]: e.target.value }))}
                                allowClear
                                style={{ width: 260 }}
                            />
                            <Button
                                onClick={() => attestationCEDEAOPrinting(eng, (numeros[eng?.codeId] || "").trim())}
                                type="primary"
                                icon={<PrinterOutlined />}
                                style={{ background: "green" }}
                                disabled={!regle || !rightsService("HCO007") || contrat?.suspendu || contrat?.resilie || contrat?.avenant?.code?.startsWith("RS") || contrat?.avenant?.code?.startsWith("SP")}
                            >
                                Imprimer
                            </Button>
                        </Space>
                    </div>
                ))}

        </Modal>
    )
}

export default ImprimerAttestationCEDEAO
